<h2 mat-dialog-title> Create New Country </h2>
<mat-dialog-content>
  <form [formGroup]="countryForm" class="dialog">
    <mat-form-field class="form-element">
      <mat-label> Country Name </mat-label>
      <input matInput placeholder="Country Name" formControlName="name">
      @if (countryForm.get('name').hasError('required')) {
        <mat-error>The country name is required</mat-error>
      }
      @if (countryForm.get('name').hasError('duplicateNames')) {
        <mat-error>This country name already exists</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="form-element">
      <mat-label> Capital </mat-label>
      <input matInput placeholder="Capital" formControlName="capital">
      @if (countryForm.get('capital').hasError('required')) {
        <mat-error>The country capital is required</mat-error>
      }
      @if (countryForm.get('capital').hasError('duplicateNames')) {
        <mat-error>This capital already exists</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="form-element">
      <mat-label> Water Temperature </mat-label>
      <input matInput min="0" type="number" placeholder="Water Temperature" formControlName="water_temp">
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="greyBtn" mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" type="submit" data-testid="submit" [disabled]="!countryForm.valid" (click)="onSubmit(countryForm.value)"> Create </button>
</mat-dialog-actions>
